import { useMutation } from 'react-query';

import { request, toastError } from '@/utils';

import message from 'antd/es/message';

export const useReport = (id: string, type: 'user' | 'article' | 'hi_session') => {
  return useMutation(
    (reason: string) => {
      return request.post<{
        report: {
          id: string;
        };
      }>('/report', { context_id: id, context_type: type, reason });
    },
    {
      onSuccess() {
        message.success('Reported');
      },
      onError(err: any) {
        toastError(err || 'failed, please try later');
      },
    },
  );
};
